// removed by extract-text-webpack-plugin
module.exports = {"content":"src-components-content-page----styles-module---content---2gEBQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-page/styles.module.css
// module id = ./src/components/content-page/styles.module.css
// module chunks = 88746230898986 116195567845805 183328146348521